import { useCallback, useEffect, useState } from 'react';
import { FiDownload } from 'react-icons/fi';
import { Link, useSearchParams } from 'react-router-dom';
import HOC from '../../components/HOC/HOC';
import { DownloadModal, SuccessfullyModal } from '../../components/Modals/Modals';
import Pagination from '../../components/Pagination/Pagination';
import { getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import img from '../../assest/loading1.gif';
import { formatDateTimeP } from '../../utils/utils';
import { formatCurrency } from '../Wallet Management/staffWalletDateUtils';
import PayoutConfirmModal from '../Manual Payouts/PayoutConfirmModal';
import pageStyles from './Payments.module.css';
import {
  canRefundPayout,
  getAccountNo,
  getCustomerName,
  getIfsc,
  getPaymentMode,
  getPerson,
  getStaffName,
  getStatus,
} from './paymentUtils';

const STATUS_OPTIONS = [
  { label: 'All Status', value: '' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Paid', value: 'Paid' },
  { label: 'Failed', value: 'Failed' },
];

const PAYMENT_TYPE_OPTIONS = [
  { label: 'All payment modes', value: '' },
  { label: 'UPI', value: 'UPI' },
  { label: 'IMPS', value: 'IMPS' },
  { label: 'NEFT', value: 'NEFT' },
  { label: 'RTGS', value: 'RTGS' },
  { label: 'Wallet', value: 'Wallet' },
];

const TRANSACTION_TYPE_OPTIONS = [
  { label: 'Credit and debit', value: '' },
  { label: 'Credit', value: 'Credit' },
  { label: 'Debit', value: 'Debit' },
];

const CATEGORY_OPTIONS = [
  { label: 'All categories', value: '' },
  { label: 'Bank', value: 'bank' },
];

const WITHDRAWAL_SHORTCUTS = [
  { label: 'All', status: '', paymentType: '', transactionType: '', category: '' },
  {
    label: 'Pending withdrawals',
    status: 'Pending',
    paymentType: '',
    transactionType: 'Debit',
    category: 'bank',
  },
  {
    label: 'Paid withdrawals',
    status: 'Paid',
    paymentType: '',
    transactionType: 'Debit',
    category: 'bank',
  },
  {
    label: 'Failed withdrawals',
    status: 'Failed',
    paymentType: '',
    transactionType: 'Debit',
    category: 'bank',
  },
  { label: 'UPI', status: '', paymentType: 'UPI', transactionType: 'Debit', category: 'bank' },
  { label: 'IMPS', status: '', paymentType: 'IMPS', transactionType: 'Debit', category: 'bank' },
  { label: 'NEFT', status: '', paymentType: 'NEFT', transactionType: 'Debit', category: 'bank' },
  { label: 'RTGS', status: '', paymentType: 'RTGS', transactionType: 'Debit', category: 'bank' },
];

const statusClass = status => {
  const value = String(status || '').toLowerCase();
  if (value === 'paid') return pageStyles.paid;
  if (value === 'pending') return pageStyles.pending;
  if (value === 'failed') return pageStyles.failed;
  return pageStyles.neutral;
};

const Payments = () => {
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [walletdata, setWalletData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [refundTarget, setRefundTarget] = useState(null);
  const [refunding, setRefunding] = useState(false);

  const page = parseInt(searchParams.get('page'), 10) || 1;
  const status = searchParams.get('status') || '';
  const paymentType = searchParams.get('paymentType') || '';
  const transactionType = searchParams.get('transactionType') || '';
  const category = searchParams.get('category') || '';
  const [pagination, setPagination] = useState({
    limit: 10,
    totalPages: 1,
    page,
    hasPrevPage: false,
    hasNextPage: false,
  });

  const fetchData = useCallback(async () => {
    await getApi(
      endPoints.getwallet(page, pagination.limit, {
        status,
        paymentType,
        transactionType,
        category,
      }),
      {
        setResponse: setWalletData,
        setLoading,
        errorMsg: 'Failed to fetch transactions!',
      }
    );
  }, [page, pagination.limit, status, paymentType, transactionType, category]);

  const handleRefund = async () => {
    if (!refundTarget?._id) return;

    const response = await postApi(
      endPoints.refundPendingTransaction,
      { transactionId: refundTarget._id },
      {
        setLoading: setRefunding,
        successMsg: 'Payout marked failed and the amount was refunded to the wallet.',
        errorMsg: 'Failed to refund payout!',
      }
    );

    setRefundTarget(null);
    if (!response) return;
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const DownloadTimesheet = useCallback(async (fromDate, toDate) => {
    setDownLoading(true);

    const data1 = await getApi(endPoints.getDownloadPayment(fromDate, toDate), {
      setResponse: () => {},
      setLoading: setDownLoading,
      errorMsg: 'Failed to download payments!',
    });

    setDownLoading(false);

    if (data1?.data) {
      const fileUrl = `https://at-lo.in/api/${data1.data}`;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = 'payments.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setShow(false);
      setShow1(true);

      setTimeout(() => {
        setShow1(false);
      }, 5000);
    }
  }, []);

  const applyFilters = (nextFilters, nextPage = 1) => {
    const next = { page: nextPage };
    if (nextFilters.status) next.status = nextFilters.status;
    if (nextFilters.paymentType) next.paymentType = nextFilters.paymentType;
    if (nextFilters.transactionType) next.transactionType = nextFilters.transactionType;
    if (nextFilters.category) next.category = nextFilters.category;
    setSearchParams(next);
    setPagination(prev => ({ ...prev, page: nextPage }));
  };

  const handlePageChange = newPage => {
    applyFilters({ status, paymentType, transactionType, category }, newPage);
  };

  const handleFilterChange = key => event => {
    applyFilters({
      status,
      paymentType,
      transactionType,
      category,
      [key]: event.target.value,
    });
  };

  useEffect(() => {
    setPagination(prevPagination => ({
      ...prevPagination,
      totalPages: walletdata?.totalPages || 1,
      hasPrevPage: walletdata?.hasPrevPage,
      hasNextPage: walletdata?.hasNextPage,
    }));
  }, [walletdata]);

  const rows = Array.isArray(walletdata?.data) ? walletdata.data : [];

  return (
    <>
      <PayoutConfirmModal
        show={Boolean(refundTarget)}
        title="Refund this payout?"
        message={`Refund ${formatCurrency(refundTarget?.amount)} for ${getStaffName(refundTarget)}. This marks the payout Failed and credits the same amount back to the staff wallet.`}
        confirmLabel="Refund amount"
        loading={refunding}
        onClose={() => setRefundTarget(null)}
        onConfirm={handleRefund}
      />
      <DownloadModal
        show={show}
        handleClose={() => setShow(false)}
        handleDownload={(fromDate, toDate) => DownloadTimesheet(fromDate, toDate)}
        loading={downloading}
      />
      <SuccessfullyModal
        show={show1}
        handleClose={() => setShow1(false)}
        text="Successfully Downloaded"
      />
      <div className={pageStyles.page}>
        <div className={pageStyles.header}>
          <div className={pageStyles.headerLeft}>
            <h6>Payments</h6>
            <p>
              Refund appears only for a full admin, and only on a pending debit payout. Paid,
              failed, and credit rows stay view-only.
            </p>
          </div>
          <div className={pageStyles.headerActions}>
            <select
              className={pageStyles.statusSelect}
              value={status}
              onChange={handleFilterChange('status')}
              aria-label="Transaction status"
            >
              {STATUS_OPTIONS.map(option => (
                <option key={option.value || 'all-status'} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <select
              className={pageStyles.statusSelect}
              value={paymentType}
              onChange={handleFilterChange('paymentType')}
              aria-label="Payment mode"
            >
              {PAYMENT_TYPE_OPTIONS.map(option => (
                <option key={option.value || 'all-modes'} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <select
              className={pageStyles.statusSelect}
              value={transactionType}
              onChange={handleFilterChange('transactionType')}
              aria-label="Transaction type"
            >
              {TRANSACTION_TYPE_OPTIONS.map(option => (
                <option key={option.value || 'all-types'} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <select
              className={pageStyles.statusSelect}
              value={category}
              onChange={handleFilterChange('category')}
              aria-label="Category"
            >
              {CATEGORY_OPTIONS.map(option => (
                <option key={option.value || 'all-categories'} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <button type="button" className={pageStyles.downloadBtn} onClick={() => setShow(true)}>
              <FiDownload color="#FFFFFF" />
              <p>Download</p>
            </button>
          </div>
        </div>

        <div className={pageStyles.tableSection}>
          <div className={pageStyles.tableSectionHeader}>
            <h6>All transactions</h6>
            <span className={pageStyles.recordCount}>
              {walletdata?.totalRecords ?? rows.length} records
            </span>
          </div>
          <div className={pageStyles.shortcuts}>
            {WITHDRAWAL_SHORTCUTS.map(shortcut => {
              const active =
                status === shortcut.status &&
                paymentType === shortcut.paymentType &&
                transactionType === shortcut.transactionType &&
                category === shortcut.category;
              return (
                <button
                  key={shortcut.label}
                  type="button"
                  className={active ? pageStyles.shortcutActive : pageStyles.shortcut}
                  onClick={() => applyFilters(shortcut)}
                >
                  {shortcut.label}
                </button>
              );
            })}
          </div>
          <div className={pageStyles.tableWrap}>
            <table className={pageStyles.table}>
              <thead>
                <tr>
                  <th className={pageStyles.colTxn}>Transaction</th>
                  <th className={pageStyles.colStaff}>Staff</th>
                  <th className={pageStyles.colDetails}>Booking</th>
                  <th className={pageStyles.colPay}>Payment</th>
                  <th className={`${pageStyles.alignRight} ${pageStyles.colAmount}`}>Amount</th>
                  <th className={pageStyles.colStatus}>Status</th>
                  <th className={pageStyles.colAction}>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className={pageStyles.loadingCell}>
                      <img src={img} alt="Loading" width={80} height={80} />
                    </td>
                  </tr>
                ) : rows.length ? (
                  rows.map((item, index) => {
                    const person = getPerson(item);
                    const txnStatus = getStatus(item);
                    const isCredit = String(item?.type || '').toLowerCase() === 'credit';

                    return (
                      <tr key={item?._id || index}>
                        <td>
                          <span className={pageStyles.primaryText}>
                            {formatDateTimeP(item?.date || item?.createdAt) || '-'}
                          </span>
                          <span className={`${pageStyles.muted} ${pageStyles.mono}`}>
                            {item?.id || item?._id || '-'}
                          </span>
                        </td>
                        <td>
                          <span className={pageStyles.primaryText}>{getStaffName(item)}</span>
                          {person.phone ? <span className={pageStyles.muted}>{person.phone}</span> : null}
                          <span className={`${pageStyles.muted} ${pageStyles.mono}`}>
                            A/c {getAccountNo(item)}
                          </span>
                          <span className={`${pageStyles.muted} ${pageStyles.mono}`}>
                            IFSC {getIfsc(item)}
                          </span>
                        </td>
                        <td>
                          <span className={pageStyles.line}>
                            <span className={pageStyles.lineLabel}>Site</span>
                            {getCustomerName(item)}
                          </span>
                          <span className={pageStyles.line}>
                            <span className={pageStyles.lineLabel}>Description</span>
                            {item?.description || '-'}
                          </span>
                          <span className={pageStyles.line}>
                            <span className={pageStyles.lineLabel}>Created by</span>
                            {item?.createdBy || '-'}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`${pageStyles.badge} ${
                              isCredit ? pageStyles.credit : pageStyles.debit
                            }`}
                          >
                            {item?.type || '-'}
                          </span>
                          <span className={pageStyles.muted}>{getPaymentMode(item)}</span>
                        </td>
                        <td
                          className={`${pageStyles.alignRight} ${
                            isCredit ? pageStyles.creditAmount : pageStyles.debitAmount
                          }`}
                        >
                          {isCredit ? '+' : '-'}
                          {formatCurrency(item?.amount)}
                        </td>
                        <td>
                          <span className={`${pageStyles.badge} ${statusClass(txnStatus)}`}>
                            {txnStatus}
                          </span>
                        </td>
                        <td>
                          <div className={pageStyles.actions}>
                            <Link className={pageStyles.viewLink} to={`/payments/details/${item?._id}`}>
                              View
                            </Link>
                            {canRefundPayout(item) ? (
                              <button
                                type="button"
                                className={pageStyles.refundButton}
                                onClick={() => setRefundTarget(item)}
                              >
                                Refund
                              </button>
                            ) : null}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="7" className={pageStyles.emptyCell}>
                      No transactions found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className={pageStyles.paginationWrap}>
            <Pagination
              limit={pagination.limit}
              totalPages={pagination.totalPages || 1}
              page={pagination.page}
              hasPrevPage={pagination.hasPrevPage}
              hasNextPage={pagination.hasNextPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(Payments);
